<div id="container">
  <div>
      <div class="text-align-center">
        <img src="/assets/images/logo.png" alt="Logo" class="logo">
      </div>

      <form id="form" [formGroup]="dataForm" (ngSubmit)="onSubmit()" novalidate>
        @if (loginInfo) {
          <mat-card [class.card-info]>
            {{loginInfo}}
          </mat-card>
        }
        @if (showFirstCard) {
          <mat-card class="animated-card">
            <mat-form-field>
              <mat-label>Username</mat-label>
              <input formControlName="username" matInput autocomplete="username" name="username"
                id="username" />
            </mat-form-field>
            @if (username.touched && !username.valid) {
              <mat-error>
                Username is required.
              </mat-error>
            }
            <mat-form-field>
              <mat-label>Password</mat-label>
              <input formControlName="password" matInput type="password"
                autocomplete="current-password" name="password" id="password" />
            </mat-form-field>
            @if (password.touched && !password.valid) {
              <mat-error>
                Password is required.
              </mat-error>
            }
            <div class="flexing">
              <span class="filler"></span>
              <button class="submitBtn" mat-raised-button type="submit" color="primary" [disabled]="isSigningIn">
                <span class="submitBtn-content">
                  {{ isSigningIn ? 'Signing In...' : 'Sign In' }}
                  @if (isSigningIn) {
                  <mat-spinner color="primary" diameter="18"></mat-spinner>
                  }
                </span>
              </button>
            </div>
          </mat-card>
        }

        @if (isError) {
          <mat-card class="card-error">
            {{serverErrorMessage}}
          </mat-card>
        }
      </form>

      @if (showAuthCard) {
        <mat-card>
          <two-factor-login
            (otpComplete)="verifyOtp($event)"
            (clearMessage)="clearMessage()"
            (setErrorMessage)="setErrorMessageEvent($event)"
            (goBackMessage)="closeAuth()">
          </two-factor-login>
        </mat-card>
      }

      @if (showCompanyCard) {
        <mat-card>
          <switch-company-login
            [userId]="userId"
            [userContactsLookupData]="userContactsLookupData"
            [currentSelectedMainContactId]="currentSelectedMainContactId">
          </switch-company-login>
        </mat-card>
      }

      <mat-card id="AppInfo">
        App Info: {{appVersion}}<br /> Api Info: {{apiInfo?.version}} [{{apiInfo?.url}}]
      </mat-card>

      @if (displayPasswordReset) {
        <div>
          <div><a [routerLink]="['/request-reset-password']" routerLinkActive="router-link-active">Forgotten your
          login details?</a></div>
        </div>
      }
  </div>
</div>
